import styled from 'styled-components';

export const StyledIconContainer = styled.span<{ hasOnClick: boolean }>`
  cursor: ${({ hasOnClick }) => (hasOnClick ? 'pointer' : 'inherit')};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    display: block;
  }
`;
